import React, { FC, useContext } from 'react';
import { useFormikContext }      from 'formik';
import { Cell, Grid }            from "styled-css-grid";

import { useFeatureFlags }                                                           from '../../../../hooks';
import { SystemEvent }                                                               from '../../../../types';
import { FieldDescription, FieldWrapper }                                            from '../../../components/forms/formik';
import { FieldLabel }                                                                from '../../../components/forms/formik/FieldLabel';
import { FinePrintMessage }                                                          from '../../../components/util/messaging/FinePrintMessage';
import { ToggleViewControl }                                                         from '../common/visualization/ui-manipulation/ToggleViewControl';
import { ProjectActivityUpdateDialogContext, ProjectActivityUpdateDialogFormValues } from './ProjectActivityUpdateDialog';
import { CorvalLogo, CorvalLogoVersions }                                            from '../../../components/product/CorvalLogo';
import { List }                                                                      from 'semantic-ui-react';
import { CorvalRecommendedStatement }                                                from '../../../components/product/CorvalRecommendedStatement';

export interface ProjectActivityUpdateAreaDetailsDisplayOptions {
	showDisplayName?: boolean,
	showDescription?: boolean,
	showPerceivedAsContinuous?: boolean,
}

interface Props extends ProjectActivityUpdateAreaDetailsDisplayOptions {}

const defaultProps: Props = {
	showDisplayName:           true,
	showDescription:           true,
	showPerceivedAsContinuous: true,
}

const ProjectActivityUpdateAreaDetails: FC<Props> = ( props ) => {
	
	let { showDisplayName, showDescription }      = props,
	    { showPerceivedAsContinuous }             = props,
	    { projectId, projectActivity, isLoading } = useContext( ProjectActivityUpdateDialogContext ),
	    form                                      = useFormikContext<ProjectActivityUpdateDialogFormValues>(),
	    featureFlags                              = useFeatureFlags();
	
	let handlePerceiveAsContinuousChanged = ( event: SystemEvent, data: { checked: boolean } ) => {
		
		form.setValues( {
			
			...form.values,
			
			perceivedAsContinuousOverride: data.checked
		} )
	}
	
	return (
		
		<>
			<Grid columns={ 'auto' } rows={ 'auto' } rowGap={ '8px' }>
				
				
				{ showPerceivedAsContinuous && (
					<Cell>
						
						<FieldWrapper>
							<FieldLabel>Display Options</FieldLabel>
						</FieldWrapper>
						
						{/* Display Toggles List */ }
						<List relaxed divided>
							<List.Item>
								
								<Grid columns={ `auto 1fr auto` } columnGap={ '20px' }>
									
									<Cell middle>
										
										<ToggleViewControl
											key={ `perceivedAsContinuousOverride-${ form.values.perceivedAsContinuousOverride ? 'active' : 'inactive' }` }
											toggle={ true }
											defaultChecked={ form.values.perceivedAsContinuousOverride }
											onChange={ handlePerceiveAsContinuousChanged }
											disabled={ isLoading }
										/>
									
									</Cell>
									<Cell middle onClick={ e => handlePerceiveAsContinuousChanged( e, { checked: !form.values.perceivedAsContinuousOverride } ) } className={ 'cursor--pointer' }>
										
										<span>Appear as Continuous</span>
									
									</Cell>
									<Cell>
										
										{/* Recommendation block */ }
										<CorvalRecommendedStatement value={ projectActivity.activity.perceivedAsContinuous ? 'on' : 'off' }/>
									
									</Cell>
									<Cell left={ 2 }>
										
										<FinePrintMessage>Displays a continuous visual line representing ongoing timing once its initial duration has concluded; Does not affect budget itemization.</FinePrintMessage>
									
									</Cell>
								
								</Grid>
							
							</List.Item>
						</List>
					
					</Cell>
				) }
			
			</Grid>
		</>
	);
};

ProjectActivityUpdateAreaDetails.defaultProps = defaultProps;

export { ProjectActivityUpdateAreaDetails }
